/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React, { useEffect, useState } from 'react';
import scriptjs from 'scriptjs';
import { shallowEqual, useSelector } from 'react-redux';
import {
  selectGoogleMapsAPIKey,
  selectGoogleMapsURL,
  selectIsInitialConfigRequestFinished,
} from '../../../store/index';

export interface BaseMapLoadingContainerProps {
  children: React.ReactNode;
}

function loadGoogleMaps(handleLoaded: () => void, googleMapsURL: string, googleMapsAPIKey: string): void {
  if (!(typeof google === 'object' && typeof google.maps === 'object')) {
    scriptjs(`${googleMapsURL}${googleMapsAPIKey}`, handleLoaded);
  } else {
    handleLoaded();
  }
}

const BaseMapLoadingContainer = ({ children }: BaseMapLoadingContainerProps) => {
  const [isMapsApiLoaded, setIsMapsApiLoaded] = useState(false);

  const isInitialConfigRequestFinished = useSelector(selectIsInitialConfigRequestFinished);
  const googleMapsAPIKey = useSelector(selectGoogleMapsAPIKey, shallowEqual);
  const googleMapsURL = useSelector(selectGoogleMapsURL, shallowEqual);

  // once the config endpoint returns with the google api information
  // download the google maps api
  useEffect(() => {
    if (isInitialConfigRequestFinished) {
      loadGoogleMaps(
        () => {
          setIsMapsApiLoaded(true);
        },
        googleMapsURL,
        googleMapsAPIKey,
      );
    }
  }, [isInitialConfigRequestFinished, googleMapsAPIKey, googleMapsURL]);

  if (isMapsApiLoaded) {
    return <>{children}</>;
  }
  return null;
};

export default BaseMapLoadingContainer;
